import React, { AllHTMLAttributes, FC } from 'react';

import { cn, resultIf } from '../../../../utils';
import { ChevronIcon } from '../../icons';

import './RotatedOpener.scoped.scss';

interface Props extends AllHTMLAttributes<HTMLDivElement> {
  active: boolean;
  onClicked?: (active: boolean) => void;
}

const RotatedOpener: FC<Props> = ({ active, onClicked, ...props }) => {
  const toggle = () => {
    onClicked!(!active);
  };
  return (
    <div
      {...props}
      className={cn('rotated-opener', resultIf(active, 'active'), props.className)}
      onClick={resultIf(onClicked !== undefined, toggle)}
    >
      <span className="rotated-opener__chevron" aria-hidden>
        <ChevronIcon direction="up" size={24} aria-hidden />
      </span>
    </div>
  );
};

export default RotatedOpener;
